import React, { HTMLProps, ReactElement } from 'react';
import { ErrorMessage, useField } from 'formik';
import cn from 'classnames';

import './TextField.scss';

export interface TextFieldProps extends Omit<HTMLProps<HTMLInputElement>, 'label' | 'name'> {
  label?: string;
  name: string;
  suffixIcon?: ReactElement;
}

const TextField: React.FC<TextFieldProps> = ({
  placeholder,
  disabled,
  label,
  type,
  className,
  name,
  height,
  readOnly,
  suffixIcon,
  maxLength,
  ...restParams
}) => {
  const [field, meta] = useField(name);

  return (
    <div className={cn(className, 'text-field')}>
      {label && (
        <label htmlFor={field.name} className="text-field-label">
          {label}
        </label>
      )}
      <div className="input-wrapper">
        {suffixIcon && <div className="suffix-icon-wrapper">{suffixIcon}</div>}
        <input
          className={cn({ 'form-control': meta.touched && meta.error }, { 'is-invalid': meta.touched && meta.error })}
          {...restParams}
          {...field}
          style={{ height }}
          type={type}
          maxLength={maxLength}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          autoComplete="off"
          aria-autocomplete="none"
        />
      </div>
      <ErrorMessage name={field.name} component="div" className="text-danger" />
    </div>
  );
};
export default TextField;
